<template>
	<div>
		<div v-for="opt in filter.inputs.mode.options" :key="opt.value" class="form-group">
			<label class="form-label label-auto">
				<input v-model="mode" type="radio" name="mode" :value="opt.value" />
				{{ opt.label }}
			</label>
		</div>
		<div class="form-group form-group-32">
			<div v-if="mode != 'without' && mode != 'with'" class="form-input span_12">
				<autocomplete
type="tag" 
					:params="{type : filter.inputs.value.params.linkedtype}" 
					:prepopulate="value" 
					:name="filter.name" 
					:minChars="1"
					@updated="updateAutocomplete" />
			</div>
		</div>
	</div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';
import Autocomplete from 'vcomponents/utilities/Autocomplete.vue'

export default{
    components: {
        Autocomplete
    },
    mixins		: [
        ListingFilterMixin
    ],

    data(){	
        return {
            mode	: '',
            value	: [], 
        }
    },

    computed	: {
        data(){
            return {
                mode	: this.mode,
                value	: this.value,
            }
        }
    },
		
    methods : {
        updateAutocomplete(value){
            this.value = [];
				
            for (var i in value){
                this.value.push(value[i]);
            }
        }
    }
}
</script>
